import React from 'react';
import Head from './Head';
import { Table, TableBody, TableContainer } from '@mui/material';
import SumRows from './SumRows';
import { useEsgTaxonomy } from 'src/Esg/hooks';
import ActivityRow from './ActivityRow';

export default function TurnoverTable() {
  const { queries } = useEsgTaxonomy();
  if (queries.isLoading) return null;

  const reportActivities = queries.reportActivities._data.filter(
    (ra) => ra.turnover_enabled
  );

  return (
    <TableContainer sx={{ overflowX: 'auto' }}>
      <Table stickyHeader>
        <Head />
        <TableBody>
          {reportActivities.map((activity) => (
            <ActivityRow key={activity.id} reportActivityId={activity.id} />
          ))}
          <SumRows />
        </TableBody>
      </Table>
    </TableContainer>
  );
}
